import {
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent,
  DialogContentText
} from '@material-ui/core';
import React, { FC, memo } from 'react';
import { Link } from 'react-router-dom';
import { viewTexts } from '../../../constants/view-texts';
import { routes } from '../../../routing/routes';
import { MuiButton } from '../../shared/form-element';

const vt = viewTexts.dialogs.projectImageSettings.redirectPage;

interface Props {
  open: boolean;
  onClose: () => void;
  koumutenId: number;
  companyId: number;
}

export const ProjectImageSettingsDialogRedirectView: FC<Props> = memo(
  ({ open, onClose, koumutenId, companyId }: Props) => (
    <Dialog disableBackdropClick={true} open={open}>
      <DialogTitle>{vt.title}</DialogTitle>
      <DialogContent>
        <DialogContentText>{vt.description}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Link to={routes.modelList(koumutenId, companyId)}>
          <MuiButton onClick={onClose} label={vt.goToModelList} />
        </Link>
      </DialogActions>
    </Dialog>
  )
);

ProjectImageSettingsDialogRedirectView.displayName =
  'ProjectImageSettingsDialogRedirectView';
